import { render, staticRenderFns } from "./EntityField.vue?vue&type=template&id=851417f4&"
import script from "./EntityField.vue?vue&type=script&lang=ts&"
export * from "./EntityField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports